import { takeLatest, put, all, call, select } from 'redux-saga/effects';
import {
  fetchPostAcqTaskData,
  fetchPostAcqTaskHistory,
  fetchPostAcqUnderwriteModalData,
  fetchPostAcqUWCensusTract,
  fetchPostAcqUWContainers,
  fetchPostAcqUWImages,
  fetchTransactionEvents,
  setPostAcqSelectedContainer,
  setPostAcqSelectedContainerId,
  appNotify,
  setPostAcqUWClientTask,
  setPostAcqUWMarketData,
  setIsFetchingPostAcqContainers,
  setIsFetchingPostAcqUWData,
  updateClientTxnOppsFromQueued,
  setPostAcqSelectedOpportunityComps,
  setPostAcqSelectedOpportunityAmherstIndicative,
  setPostAcqContainers,
  setPostAcqTransientValuation,
  setPostAcqSelectedValuation,
  setPostAcqSelectedProformaInputsContainer,
  setPostAcqSelectedOpportunityCensusTracts,
  setPostAcqSelectedTaskEventHistory,
  setPostAcqSelectedTaskHistory,
  setPostAcqWorkflowLoadingOverlayState,
  loadPostAcqTasks
} from 'store/actions';
import { selectedContainerIdSelector, selectedPostAcqTaskSelector } from 'store/selectors'
import { getWithToken, getWithTokenV2, postWithToken, postWithTokenV2 } from 'api/network';
import * as postAcqTaskUWDataService from 'services/postAcqTaskUWDataService';
import { sendClientLog } from 'services/logService';
import { Constants } from 'utilities/constants';

export function* postAcqTaskSaga() {
  
  yield takeLatest(fetchPostAcqTaskData, function* ({ payload }) {
    try {
      yield put(setIsFetchingPostAcqUWData(true));

      const { taskId, selectedContainerId = null, history } = payload;
      const taskData = yield getTaskData(taskId, history);
      if (!taskData) return;
      // if(taskData && taskData.length === 0) {
      //   history.push(Constants.Routes.POSTACQ)
      //   yield put(appNotify(`The task ${taskId} was not found`, 'error'));
      //   yield put(setIsFetchingPostAcqUWData(false));
      //   return;
      // }

      // if(taskData && taskData[0].isDeleted) {
      //   history.push(Constants.Routes.POSTACQ)
      //   yield put(appNotify(`The task ${taskId} is deleted`, 'error'));
      //   yield put(setIsFetchingPostAcqUWData(false));
      //   return;
      // }

      yield all([ // Clear out current data
        put(setPostAcqTransientValuation(null)),
        put(setPostAcqSelectedValuation(null)),
        put(setPostAcqSelectedOpportunityComps([])),
        put(setPostAcqSelectedProformaInputsContainer(null)),
        put(setPostAcqSelectedOpportunityAmherstIndicative(null)),
        put(setPostAcqSelectedOpportunityCensusTracts([]))
      ]);

      // const currentSelectedContainerId = yield select(selectedContainerIdSelector);

      // const [fetchedOpp] = yield all([
      //   call(getLatestClientTaskData, taskId),
      //   selectedContainerId !== currentSelectedContainerId
      //     ? put(setPostAcqSelectedContainerId(selectedContainerId, taskId, false)) // Pass false to prevent loading flag being turned off by setSelectedContainerId, in case another call takes longer
      //     : call(fetchUWSnapshotData, taskId, selectedContainerId),
      //   put(fetchPostAcqUWCensusTract(taskId)),
      // ])

      yield all([
        call(getLatestClientTaskData, taskData),
        call(fetchUWSnapshotData, taskId, taskData),
        put(fetchPostAcqUWCensusTract(taskId)),
      ])

      yield put(fetchPostAcqUWImages(taskData.workflowTask));

      yield call(getTaskAndEventHistory, taskData.workflowTask);

      sendClientLog('Info', `Post-Acq UW - User opened task page - task ${taskId}`);

      yield put(updateClientTxnOppsFromQueued(Constants.SignalRUpdateTarget.POSTACQUWTASK));
      
      yield put(setIsFetchingPostAcqUWData(false)); 
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
      yield put(setIsFetchingPostAcqUWData(false));
    }
  });

  yield takeLatest(fetchPostAcqUnderwriteModalData, function* ({ payload }) {
    try {
      yield put(setIsFetchingPostAcqUWData(true, true));

      const { taskId, loadInstanceId, valuationId } = payload;
      const taskData = yield getTaskData(taskId, null, loadInstanceId, valuationId);
      if (!taskData) return;

      // yield all([ // Clear out current data
      //   put(setPostAcqTransientValuation(null)),
      //   put(setPostAcqSelectedValuation(null)),
      //   put(setPostAcqSelectedOpportunityComps([])),
      //   put(setPostAcqSelectedProformaInputsContainer(null)),
      //   put(setPostAcqSelectedOpportunityAmherstIndicative(null)),
      //   put(setPostAcqSelectedOpportunityCensusTracts([]))
      // ]);

      yield all([
        call(getLatestClientTaskData, taskData, true),
        call(fetchUWSnapshotData, taskId, taskData, loadInstanceId),
        put(fetchPostAcqUWCensusTract(taskId)),
      ])

      yield put(fetchPostAcqUWImages(taskData.workflowTask));
      
      yield put(setIsFetchingPostAcqUWData(false, true)); 
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
      yield put(setIsFetchingPostAcqUWData(false, true));
    }
  });

  yield takeLatest(fetchPostAcqUWCensusTract, function* ({ payload: transactionOpportunityId }) {
    yield call(postAcqTaskUWDataService.getPostAcqUWCensusTract, transactionOpportunityId);
  });

  yield takeLatest(fetchPostAcqUWImages, function* ({ payload: fetchedOpp }) {
    yield call(postAcqTaskUWDataService.getPostAcqUWImages, fetchedOpp);
  });

  yield takeLatest(fetchPostAcqUWContainers, function* ({ payload: transactionOpportunityId }) {
    yield put(setIsFetchingPostAcqContainers(true));
    let containers = null;
    try {
      const containersResponse = yield getWithToken(`/api/underwrite/proformaInputsContainer/${transactionOpportunityId}`);
      containers = yield containersResponse.json();
      sendClientLog('Info', `Post-Acq UW - User fetched containers - task ${transactionOpportunityId}`);
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
    }
    yield put(setPostAcqContainers(containers));
    yield put(setIsFetchingPostAcqContainers(false));
  });

  yield takeLatest(loadPostAcqTasks, function* ({ payload: taskIds }) {
    try {
      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: true, message: 'Starting load...' }));
      yield postWithTokenV2(`/api/postAcquisition/tasks/load`, taskIds);
      sendClientLog('Info', `Post-Acq Workflow - User loaded task data - taskIds ${taskIds}`);
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
    }
    finally {
      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: false, message: null }));
    }
  });
}

export function* fetchPostAcqUWSnapshotDataSaga() {
  yield takeLatest(setPostAcqSelectedContainerId, function* ({ payload }) {
    const { selectedContainerId, transactionOpportunityId, shouldEndLoading = true } = payload;
    const transactionOpportunity = yield select(selectedPostAcqTaskSelector);

    const oppId = transactionOpportunityId ?? transactionOpportunity.id;
    yield call(fetchUWSnapshotData, oppId, selectedContainerId);
    if (shouldEndLoading) yield put(setIsFetchingPostAcqUWData(false)); 
  });
}

// const getUrlWithContainerIdParam = (selectedContainerId) => (baseUrl) => {
//   if (!selectedContainerId) {
//     return baseUrl
//   }

//   return baseUrl + `?proformaInputsContainerId=${selectedContainerId}`
// }

function* fetchUWSnapshotData(taskId, taskData, loadInstanceId) {
  const isUWModal = loadInstanceId != null;
  try {
    yield put(setIsFetchingPostAcqUWData(true, isUWModal));

    // const getUrlWithContainerIdParamFunc  = getUrlWithContainerIdParam(selectedContainerId);
    let indicativesUrl = `/api/postAcquisition/tasks/${taskId}/indicatives`;
    let compsUrl = `/api/postAcquisition/tasks/${taskId}/comps`;
    if (isUWModal) {
      const query = `?loadInstanceId=${loadInstanceId}`;
      indicativesUrl += query;
      compsUrl += query;
    }

    const [indicativesResponse, compsResponse] = yield all([
      getWithTokenV2(indicativesUrl),
      getWithTokenV2(compsUrl)
    ]) 
    const indicativesData = indicativesResponse[0];
    let compsData = compsResponse;

    const indicativesToHistoricalContainerData = {
      beds: indicativesData.beds,
      baths: indicativesData.baths,
      lotSize: indicativesData.lotSize,
      normalAvm: indicativesData.normalAvm,
      normalAvmQuartileOne: indicativesData.normalAvmQuartileOne,
      normalAvmQuartileThree: indicativesData.normalAvmQuartileThree,
      normalAvm90thPctileValue: indicativesData.normalAvm90thPctileValue,
      normalAvm95thPctileValue: indicativesData.normalAvm95thPctileValue,
      schoolScoreElementary: indicativesData.schoolScoreElementary,
      schoolScoreMiddle: indicativesData.schoolScoreMiddle,
      schoolScoreHigh: indicativesData.schoolScoreHigh,
      schoolScoreAverage: indicativesData.schoolScoreAverage,
      schoolDistrict: indicativesData.schoolDistrict,
      sqft: indicativesData.sqft,
      viewingReadOnlyMode: false,
      yearBuilt: indicativesData.yearBuilt
    }

    yield put(setPostAcqSelectedContainer(indicativesToHistoricalContainerData, isUWModal));
    if (!compsData) compsData = [];
    yield put(setPostAcqSelectedOpportunityComps(compsData, isUWModal));

    const { valuationContainer } = taskData;
    const proformaInputsContainer = {
      rentProformaInputs: valuationContainer.rentProformaInput != null? [valuationContainer.rentProformaInput] : [],
      arvProformaInputs: valuationContainer.arvProformaInput != null ? [valuationContainer.arvProformaInput] : [],
      lotValueProformaInputs: valuationContainer.lotValueProformaInput != null ? [valuationContainer.lotValueProformaInput] : [],
      asIsValueProformaInputs: valuationContainer.asIsValueProformaInput != null ? [valuationContainer.asIsValueProformaInput] : [],
      reducedRentProformaInputs: valuationContainer.reducedRentProformaInput != null ? [valuationContainer.reducedRentProformaInput] : [],
      reducedAfterRepairValueProformaInputs: valuationContainer.reducedAfterRepairValueProformaInput != null ? [valuationContainer.reducedAfterRepairValueProformaInput] : [],
      selectedValuationId: valuationContainer.selectedValuationId,
      valuations: valuationContainer.postAcquisitionValuations.map(val => {
        return {
          createdOn: val.createdOn,
          id: val.id,
          isLatest: val.isLatest, // needed? old Post-acq doesn't have. check logic for how its proforma picks a val to show
          notes: val.notes,
          type: null, // missing
          user: val.createdByUser,
          valuationInput: {
            afterRepairValue: val.afterRepairValue,
            afterRepairValueType: val.afterRepairValueType,
            rent: val.rent,
            rentType: val.rentType,
            lotValue: val.lotValue,
            lotValueType: val.lotValueType,
            asIsValue: val.asIsValue,
            asIsValueType: val.asIsValueType,
            reducedRent: val.reducedRent,
            reducedRentType: val.reducedRentType,
            reducedAfterRepairValue: val.reducedAfterRepairValue,
            reducedAfterRepairValueType: val.reducedAfterRepairValueType
          },
          valuationsComps: val.postAcquisitionValuationComps.map(comp => {
            return { compId: comp.postAcquisitionCompId }
          }),
          postAcquisitionLoadInstanceId: val.postAcquisitionLoadInstanceId
        }
      })
    };
    const amherstIndicative = { // Only used by PostAcqUWHeader (isAmherstManaged), PostAcqUWGrid (streetName, censusTractGeoId)
      isAmherstManaged: indicativesData.isAmherstManaged,
      streetName: indicativesData.streetName,
      censusTractGeoId: indicativesData.censusTractGeoId
    }
    yield put(setPostAcqSelectedOpportunityAmherstIndicative(amherstIndicative, isUWModal))
    yield postAcqTaskUWDataService.getProformaInputsAndValuation(proformaInputsContainer, isUWModal)
  } catch (error) {
    yield put(appNotify(error.message, 'error'));
  }
}

// PROPERTY UW
function* getLatestClientTaskData(taskData, isUWModal) { // TODO: get WorkflowTaskDto from backend (this shares structure with workflow grid data, to allow single signalR action type to update both grid and UW page)
  try {
    const { workflowTask, markets } = taskData;
    // const res = yield getWithToken(`/api/underwrite/workflow/opportunity/${transactionOpportunityId}`);
    // const fetchedOpp = yield res.json();

    const taskDataToClientTask = {
      id: workflowTask.id,
      isProcessing: workflowTask.isProcessing, // need to create on  backend
      notes: workflowTask.notes,
      beds: workflowTask.beds,
      baths: workflowTask.baths,
      sqft: workflowTask.sqft,
      yearBuilt: workflowTask.yearBuilt,
      street: workflowTask.street,
      city: workflowTask.city,
      state: workflowTask.state,
      zipCode: workflowTask.zipCode,
      latitude: workflowTask.latitude,
      longitude: workflowTask.longitude
    }

    yield put(setPostAcqUWClientTask(workflowTask, isUWModal)); // Update UW txnOpp record with latest
    yield put(setPostAcqUWMarketData({ amherstEstimatedAMI: taskData.markets.amherstEstimatedAMI }, isUWModal));
    // return fetchedOpp;
  }
  catch (error) {
    yield put(appNotify(error.message, 'error'));
  }
}

function* getTaskData(taskId, history, loadInstanceId, valuationId) {
  const isUWModal = loadInstanceId != null;
  try {
    let url = `/api/postAcquisition/tasks/${taskId}/details`;
    const params = [];
    if (loadInstanceId != null) params.push(`loadInstanceId=${loadInstanceId}`);
    if (valuationId != null) params.push(`valuationId=${valuationId}`);
    if (params.length) url += `?${params.join('&')}`;
    const fetchedTask = yield getWithTokenV2(url);
    return fetchedTask;
  }
  catch (error) {
    history && history.push(Constants.Routes.POSTACQ_WORKFLOW)
    yield put(appNotify(error.message, 'error'));
    yield put(setIsFetchingPostAcqUWData(false, isUWModal));
    return null;
  }
}

function* getTaskAndEventHistory(task) {
  function* taskHistoryCallback(tasks) {
    yield put(setPostAcqSelectedTaskHistory(tasks));
  }
  function* eventHistoryCallback(eventHistory) {
    yield put(setPostAcqSelectedTaskEventHistory(eventHistory));
  }

  yield all([
    put(fetchPostAcqTaskHistory(task.assetId, taskHistoryCallback)),
    put(fetchTransactionEvents(task.asgPropID, task.sqft, eventHistoryCallback))
  ]);
}